<template>
    <div class="video-comments">
        <h3>Comments</h3>
        <video-comments-list :comments="comments" group="root" :video="video" :serie="serie"></video-comments-list>
        <video-comment-form :video="video" :serie="serie"></video-comment-form>
    </div>
</template>
<script>
    export default {

        props: {
            video: {
                type: Object,
                required: true,
            },
            serie: {
                type: Object,
                required: true,
            },
            comments: {
                type: Array,
                required: true,
            },
        }
    }
</script>
